import { capitalizeWordsRemoveDash, limitChars } from "../../../../utils/text.utils";
import { getCategoryUrl } from "../../../../utils/url.utils";

export const useBreadcrumb = (data = {}) => {
  const breadcrumbPaths = [
    // Category
    {
      label: capitalizeWordsRemoveDash(
        data?.category_action_url || "Category"
      ),
      to: data?.category_action_url
        ? getCategoryUrl(data.category_action_url)
        : null,
    },

    // Sub Category
    {
      label: capitalizeWordsRemoveDash(
        data?.sub_category_action_url || ""
      ),
      to:
        data?.category_action_url && data?.sub_category_action_url
          ? getCategoryUrl(
              `${data.category_action_url}/${data.sub_category_action_url}`
            )
          : null,
    },

    // Product (last - not clickable)
    {
      label: limitChars(data?.product_name || data?.name || "", 10) || "...",
      to: null,
    },
  ];

  // remove empty labels
  return breadcrumbPaths.filter(item => item.label);
};